<template>
  <div class="edit-record">
    <a-table
      class="dataTabsTable"
      bordered
      :pagination="pagination"
      :columns="table.columns"
      :rowKey="record => record.id"
      :dataSource="table.data"
      :loading="table.loading"
      @change="handleTableChange"
      :scroll="{y: 'calc(100% - 43px)'}">
    </a-table>
  </div>
</template>

<script>
import { getEditRecord, getEquipmentDocument } from '@/api/equipmentLedger'
export default {
  name: 'DocumentInfo',
  props: {
    model: Object
  },
  watch: {
    model: {
      handler (model) {
        if (model) {
          this.model = model
          this.initTableData()
        }
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      table: {
        data: [],
        columns: [
          {
            title: '序号',
            customRender: (text, record, index) => {
              return index + 1
            },
            width: 80
          },
          {
            title: '字段名称',
            dataIndex: 'label'
          },
          {
            title: '修改前值',
            dataIndex: 'previous'
          },
          {
            title: '修改后值',
            dataIndex: 'later'
          },
          {
            title: '修改人',
            dataIndex: 'updateName',
            width: 200
          },
          {
            title: '修改时间',
            dataIndex: 'updateTime'
          }
        ],
        loading: false
      },
      model: {},
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      },
      searchModel: {}
    }
  },
  methods: {
    // 获取编辑记录
    initTableData () {
      const params = {
        equipmentId: this.model.id,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        paging: true
      }
      getEditRecord(params).then(res => {
        if (res.status === 0) {
          this.table.data = res.data.list
          this.pagination.total = res.data.total
        }
      })
    },
    handleTableChange (pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.initTableData()
    }
  }
}
</script>

<style lang="less" scoped>
.edit-record{
  height: 100%;
}
.table /deep/ .ant-table-thead > tr > th {
  background: rgba(8, 64, 159, 0.1);
}
.table /deep/ .ant-table-tbody > tr > td {
  padding: 10px;
}
.dataTabsTable {
  height: 100%;
  /deep/.ant-spin-nested-loading {
    height: 100%;
    .ant-spin-container {
      height: 100%;
      .ant-table {
        height: calc(100% - 64px);
        .ant-table-content {
          height: 100%;
          .ant-table-scroll {
            height: 100%;
            .ant-table-placeholder {
              border-right: 1px solid #b9deff;
              border-bottom: 1px solid #b9deff;
              border-top: 1px solid #b9deff;
            }
          }
        }
      }
      .ant-table-pagination {
        margin-right: 5px;
      }
    }
  }
}
</style>
